/**
 * Navegação do site.
 */
export enum Links {
  // Relatórios de Atividades (módulo)
  Relatorios = '/relatorios',
  Relatorios_Aprovacao = '/relatorios/aprovacao',
  Relatorios_Corregedoria = '/relatorios/corregedoria',

  Auditorias_Index = '/auditorias',
  Auditorias_LogsUso = '/auditorias/logs-de-uso',
  Auditorias_LogsEmails = '/auditorias/logs-de-emails',
  Auditorias_LogsTasks = '/auditorias/logs-de-tarefas',
  Auditorias_RateLimit = '/auditorias/rate-limit',

  Acoes_Criar = '/acoes/criar',
  Acoes_Editar = '/acoes/editar',
  Acoes_Index = '/acoes',
  Ajuda = '/ajuda',
  Atuacoes_Criar = '/atuacoes/criar',
  Atuacoes_Editar = '/atuacoes/editar',
  Atuacoes_Index = '/atuacoes',
  Auth_Google = '/auth/google',
  Auth_Login = '/login',
  Auth_Logout = '/logout',
  Auth_Obter_Token = '/login-token',
  Calendario_Criar = '/feriados/criar',
  Calendario_Editar = '/feriados/editar',
  Calendario_Index = '/feriados',
  ChangeLog = '/changelog',
  Comarcas_Criar = '/comarcas/criar',
  Comarcas_Editar = '/comarcas/editar',
  Comarcas_Index = '/comarcas',
  Configuracoes_Index = '/configuracoes',
  ConselhoSuperior_Index = '/conselho-superior',
  ConselhoSuperior_Editar = '/conselho-superior/editar',
  Defensor_Timeline = '/defensor/timeline',
  Defensoria_Criar = '/defensoria/criar',
  Defensoria_Editar = '/defensoria/editar',
  Defensoria_Index = '/defensoria',
  Direito_Index = '/direito',
  Diretoria_Criar = '/diretoria/criar',
  Diretoria_Editar = '/diretoria/editar',
  Diretoria_Index = '/diretoria',
  Distrito_Criar = '/distrito/criar',
  Distrito_Editar = '/distrito/editar',
  Distrito_Index = '/distrito',
  Eventos_Index = '/eventos',
  Estagiario_Frequencia_Painel = '/estagiario/frequencia/resumo',
  Estagiario_Folha_Atual = '/estagiario/folha-atual',
  Estagiario_Minhas_Folhas = '/estagiario/minhas-folhas',
  Estagiario_Index_Public = '/estagiario/public',
  Folha_Frequencia_Editar = '/folha-frequencia',
  Folha_Frequencia_Index = '/folhas',
  /** Folhas por mês (`PerMonthPage`). */
  Folhas_Por_Mes = '/folhas',
  /** Folhas por estagiário (`PerInternPage`): `/folhas/:estagiarioId`. */
  Folhas_Por_Estagiario = '/folhas',
  Folha_Frequencia_Pendencias = '/folhas/pendencias',
  Funcao_Criar = '/funcao/criar',
  Funcao_Editar = '/funcao/editar',
  Funcao_Index = '/funcao',
  SimuladorFolha_Index = '/simulador-folha',
  Historico_Index = '/historico',
  Home = '/home',
  Index = '/',
  Instituicoes_Criar = '/instituicoes/criar',
  Instituicoes_Editar = '/instituicoes/editar',
  Instituicoes_Index = '/instituicoes',
  Atividades_Pendentes = '/atividades/pendentes',
  Movimentacoes_Criar = '/atividades/criar',
  Movimentacoes_Editar = '/atividades/editar',
  Movimentacoes_Index = '/atividades/lista',
  Movimentacoes_Lista = '/atividades/pesquisa',
  Movimentacoes_Tipos_Criar = '/atividades/tipo/criar',
  Movimentacoes_Tipos_Editar = '/atividades/tipo/editar',
  Movimentacoes_Tipos_Index = '/atividades/tipo',
  Nao_Autorizado = '/nao-autorizado',
  Nao_Existe = '/nao-existe',
  Notificacoes_index = '/notificacoes',
  Nucleo_Criar = '/nucleo/criar',
  Nucleo_Editar = '/nucleo/editar',
  Nucleo_Index = '/nucleo',
  Pessoa_Aniversarios = '/pessoa/aniversarios',
  Pessoa_Assessores = '/pessoa/assessores',
  Pessoa_Criar = '/pessoa/criar',
  Pessoa_Editar = '/pessoa/editar',
  Pessoa_Index = '/pessoa',
  Predio_Criar = '/predio/criar',
  Predio_Editar = '/predio/editar',
  Predio_Index = '/predio',
  ProcessoSeletivo_Criar = '/processo-seletivo/criar',
  ProcessoSeletivo_Editar = '/processo-seletivo/editar',
  ProcessoSeletivo_Index = '/processo-seletivo',
  ProcessoSeletivo_Analises = '/processo-seletivo/analises',
  Candidato_Detalhes = '/processo-seletivo/candidato',
  Candidato_Inscricao = '/candidato/inscricao',
  Candidato_Inscricao_Confirmacao = '/candidato/inscricao-confirmacao',
  Candidato_Index = '/processo-seletivo/candidatos',
  Candidato_Gestao_Arquivos = '/processo-seletivo/candidatos/gestao-arquivos',
  Candidato_Login = '/candidato/login',
  Candidato_Meus_Processos = '/candidato/meus-processos',
  ProcessoSeletivo_NaoDisponivel = '/processo-seletivo/nao-disponivel',
  Recuperar = '/recuperar',
  Regras = '/regras',
  Relatorio_Atendimentos_Solar = '/relatorios/solar/atendimentos',
  Relatorio_Defensores = '/relatorios/defensores',
  Relatorio_Estagiarios = '/relatorios/estagiarios',
  Relatorio_Ferias = '/relatorios/ferias',
  Relatorio_Lotacoes = '/relatorios/lotacoes',
  Relatorio_Lotacoes_public = '/relatorios/lotacoes/publico',
  Relatorio_Movimentacoes = '/atividades/tabela',
  Relatorio_Nucleos = '/relatorios/nucleos',
  Relatorios_Criar = '/relatorios/criar',
  Pontuacoes_Index = '/pontuacoes',
  Setor_Criar = '/setor/criar',
  Setor_Editar = '/setor/editar',
  Setor_Index = '/setor',
  Setor_Relatorio_Colaboradores = '/setor/relatorio-colaboradores',
  TrocarSenha = '/trocarsenha',
  Usuario_Profile = '/usuario/perfil',
  Sessoes_Index = '/usuario/sessoes',
  Sessoes_Legacy = '/sessoes',
  /** Utilitários internos (ex.: PDF DPE embutido). */
  Utilitarios_PdfDpe = '/utilitarios/pdf-dpe',
  Varas_Criar = '/varas/criar',
  Varas_Editar = '/varas/editar',
  Varas_Index = '/varas',
  Veirifique_Email = '/verifique-email',
  TipoGasto_Criar = '/office/tipo-gasto/criar',
  TipoGasto_Editar = '/office/tipo-gasto/editar',
  TipoGasto_Index = '/office/tipo-gasto',
  Gasto_Criar = '/office/gasto/criar',
  Gasto_Editar = '/office/gasto/editar',
  Gasto_Index = '/office/gasto',
  Versoes_index = '/versoes',
  Vinculos_Colaboradores_Index = '/vinculos_colaborador',
  Vinculos_Defensor_Index = '/vinculos_defensor',
  Vinculos_Estagio_Index = '/vinculos_estagio',
  Vinculos_Colaboradores_Criar = '/vinculos_colaborador/criar',
  Vinculos_Defensor_Criar = '/vinculos_defensor/criar',
  Vinculos_Editar = '/vinculos/editar',
  Vinculos_Estagio_Criar = '/vinculos_estagio/criar',
  Vinculos_Index = '/vinculos',
}

/** Manual do sistema na wiki interna. */
export const AJUDA_WIKI_URL =
  'http://wiki.defensoria.se/pt-br/sistemas/sgi/home';

/** Upstream HTTP do editor PDF (proxy reverso em `/pdf-dpe`). */
export const ILOVE_DPE_UPSTREAM_URL = 'http://ilovedpe.defensoria.se/';

/**
 * Caminho same-origin do PDF DPE (proxy na API).
 * Usa o mesmo protocolo do SGI e evita bloqueio de conteúdo misto.
 */
export const PDF_DPE_EMBED_PATH = '/pdf-dpe/';

export default Links;
